import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b0af5e886e100014b85320_1785801327525_52b0feb8/devrosai/src/app/about/page.tsx");
